import { createSlice } from '@reduxjs/toolkit';

export const providerItemsSlice = createSlice({
  name: 'providers',
  initialState: {
    isFetching: false,
    data: {}
  },
  reducers: {
    getProviderItems: state => {
      state.isFetching = true;
    },
    getProviderItemsSuccess: (state, action) => {
      state.isFetching = false;
      state.data = action.payload;
    }
  }
});

export default providerItemsSlice.reducer;

const {
  getProviderItems,
  getProviderItemsSuccess
} = providerItemsSlice.actions;

const getProviderItemsData = (addressGuids, start, size) => {
  return async (dispatch) => {
    dispatch(getProviderItems());
    return fetch(new Request(`/api/search/provider/get?locationIds=${addressGuids.join('|')}&start=${start}&size=${size}&sort=az`, {
      method: 'GET'
    }))
      .then(response => response.json()).then(json => {
        dispatch(getProviderItemsSuccess(json));
      });
  };
};

export { getProviderItemsData };